/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Billing_AnnuallyInputs */

const en_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annually`)
};

const es_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const fr_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const de_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const ja_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年払い`)
};

const zh_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年付`)
};

const ar_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوياً`)
};

const id_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahunan`)
};

const it_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const ru_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За год`)
};

const pt_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const ko_pricing_billing_annually = /** @type {(inputs: Pricing_Billing_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간`)
};

/**
* | output |
* | --- |
* | "Annually" |
*
* @param {Pricing_Billing_AnnuallyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_billing_annually = /** @type {((inputs?: Pricing_Billing_AnnuallyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Billing_AnnuallyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_billing_annually(inputs)
	if (locale === "es") return es_pricing_billing_annually(inputs)
	if (locale === "fr") return fr_pricing_billing_annually(inputs)
	if (locale === "de") return de_pricing_billing_annually(inputs)
	if (locale === "ja") return ja_pricing_billing_annually(inputs)
	if (locale === "zh") return zh_pricing_billing_annually(inputs)
	if (locale === "ar") return ar_pricing_billing_annually(inputs)
	if (locale === "id") return id_pricing_billing_annually(inputs)
	if (locale === "it") return it_pricing_billing_annually(inputs)
	if (locale === "ru") return ru_pricing_billing_annually(inputs)
	if (locale === "pt") return pt_pricing_billing_annually(inputs)
	return ko_pricing_billing_annually(inputs)
});